/*
  DKY | Find my size - tambahan tanpa menyentuh dokoyo-size-guide.js.

  1) TAB DAFTAR MODEL: kotak alat ukur dibungkus, lalu daftar model ditempel
     di kiri (desktop) / di atas-bawah (HP, diatur lewat CSS order). Model yang
     sedang dibuka diberi warna beda. Tab hanya muncul saat kotak ukur terbuka.
  2) TAB "ALL MODELS" paling atas/kiri: kembali ke tampilan semua kartu model.
     Caranya menekan tombol tutup bawaan alat ukur (.sg-x) - satu-satunya cara
     yang benar-benar mengembalikan layar pemilih; window.DokoyoSizeGuide.reset()
     tidak melakukannya.
  3) LABEL KARTU MODEL: baris ukuran ditulis ulang jadi "My Size : Measure Now"
     atau "My Size : L". Ukuran aslinya disimpan di data-dky-raw supaya tidak
     ikut tertimpa saat ditulis ulang berkali-kali.
  4) TOMBOL BELANJA model yang sedang dibuka, di bawah kotak.
  5) "MEASURE ME INSTEAD" di tabel ukuran: setelah alat ukur terbuka, halaman
     digulirkan ke alat ukurnya - dengan jarak aman dari header, dan dengan
     cadangan lompat langsung bila peramban mengabaikan smooth scroll.

  Alat ukurnya tidak diubah. Pindah model memakai API resmi
  window.DokoyoSizeGuide.open(chartKey).
*/
(function () {
  if (window.__dkyFmsExtra) return;
  window.__dkyFmsExtra = true;

  var FALLBACK = {
    hipster: 'Hipster', thong: 'Thong', midwaist: 'Midwaist',
    highwaist: 'Highwaist', bralette: 'Bralette', tubebra: 'Tube Bra'
  };
  var SCROLL_OFFSET = 90;

  var host, cfg = {}, styles = [], active = null;
  var shell, tabsEl, shopEl, mainEl, knownSizes = {};

  function parse(raw, fallback) {
    if (!raw) return fallback;
    try { return JSON.parse(raw); } catch (e) { return fallback; }
  }

  function labelOf(st) {
    if (st.label && String(st.label).trim()) return st.label;
    return FALLBACK[st.chart] || st.chart;
  }

  /* Gulir yang bisa diandalkan: hormati mode hemat gerak, dan kalau smooth
     scroll diabaikan peramban, lompat langsung. */
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    if (y < 0) y = 0;
    var from = window.pageYOffset;
    if (Math.abs(from - y) < 4) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { window.scrollTo(0, y); return; }
    try { window.scrollTo({ top: y, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, y); return; }
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - from) < 2) window.scrollTo(0, y);
    }, 350);
  }

  /* Ukuran asli dibaca dari data-dky-raw kalau kartunya sudah ditulis ulang,
     supaya tidak ikut membaca teks "My Size : ...". */
  function rawSizeOf(sizeEl) {
    if (sizeEl.hasAttribute('data-dky-raw')) return sizeEl.getAttribute('data-dky-raw');
    return sizeEl.classList.contains('none') ? '' : sizeEl.textContent.trim();
  }

  function harvestSizes(root) {
    var picks = root.querySelectorAll('.pickgrid [data-pick]');
    if (!picks.length) return;
    Array.prototype.forEach.call(picks, function (b) {
      var k = b.getAttribute('data-pick');
      var s = b.querySelector('.pick-size');
      if (!s) return;
      knownSizes[k] = rawSizeOf(s);
    });
  }

  /* "My Size : Measure Now" / "My Size : L" di tiap kartu model. */
  function relabelPicks(root) {
    if (cfg.mySizeLabel === false) return;
    var prefix = cfg.mySizeLabel || 'My Size';
    var measure = cfg.measureLabel || 'Measure Now';
    var picks = root.querySelectorAll('.pickgrid [data-pick]');
    Array.prototype.forEach.call(picks, function (b) {
      var s = b.querySelector('.pick-size');
      if (!s) return;
      if (!s.hasAttribute('data-dky-raw')) {
        s.setAttribute('data-dky-raw', s.classList.contains('none') ? '' : s.textContent.trim());
      }
      var raw = s.getAttribute('data-dky-raw');
      s.textContent = prefix + ' : ' + (raw ? raw : measure);
    });
  }

  function iconFor(st) {
    if (st.img) {
      return '<img src="' + st.img + '" alt="" loading="lazy"' +
             (cfg.invertActiveIcon ? ' class="dky-fms-inv"' : '') + '>';
    }
    return '<svg viewBox="0 0 64 64" stroke-width="2" stroke-linecap="round" ' +
           'stroke-linejoin="round" aria-hidden="true"><circle cx="32" cy="32" r="20"/></svg>';
  }

  function allTabHtml() {
    if (cfg.showAllTab === false) return '';
    return '<button type="button" class="dky-fms-tab dky-fms-tab--all" data-fms-all>' +
      '<span class="dky-fms-allic" aria-hidden="true"><i></i><i></i><i></i><i></i></span>' +
      '<span class="dky-fms-tabname">' + (cfg.allLabel || 'All models') + '</span>' +
    '</button>';
  }

  function buildTabs() {
    if (!styles.length) return '';
    var head = cfg.tabsTitle ? '<p class="dky-fms-tabhead">' + cfg.tabsTitle + '</p>' : '';
    return head + allTabHtml() + styles.map(function (st) {
      var got = knownSizes[st.chart] || '';
      return '<button type="button" class="dky-fms-tab" data-fms-tab="' + st.chart + '">' +
        iconFor(st) +
        '<span class="dky-fms-tabname">' + labelOf(st) + '</span>' +
        (got ? '<span class="dky-fms-tabsize">' + got + '</span>' : '') +
      '</button>';
    }).join('');
  }

  function styleOf(key) {
    for (var i = 0; i < styles.length; i++) if (styles[i].chart === key) return styles[i];
    return null;
  }

  function paintActive() {
    if (!tabsEl) return;
    Array.prototype.forEach.call(tabsEl.querySelectorAll('[data-fms-tab]'), function (b) {
      var on = b.getAttribute('data-fms-tab') === active;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function paintShop() {
    if (!shopEl) return;
    var st = active ? styleOf(active) : null;
    if (!st || !st.shop || !cfg.showShop) { shopEl.innerHTML = ''; return; }
    var tpl = cfg.shopTemplate || 'Shop {model} now';
    var label = (st.shopLabel && String(st.shopLabel).trim())
      ? st.shopLabel
      : tpl.replace('{model}', labelOf(st)).replace('[model]', labelOf(st));
    shopEl.innerHTML = '<a class="dky-fms-shopbtn" href="' + st.shop + '">' + label + '</a>';
  }

  function isPicker(root) { return !!root.querySelector('.pickgrid'); }

  /* Kembali ke daftar semua model. Tombol tutup bawaan alat ukur yang
     benar-benar memunculkan layar pemilih lagi. */
  function backToAll() {
    var root = host && host.querySelector('.dokoyo-sg-root');
    if (!root) return;
    var x = root.querySelector('.sg-x');
    if (x) x.click();
    active = null;
    setTimeout(sync, 60);
  }

  function sync() {
    var root = host && host.querySelector('.dokoyo-sg-root');
    if (!root || !shell) return;
    harvestSizes(root);
    var picker = isPicker(root);
    if (picker) { active = null; relabelPicks(root); }
    if (tabsEl) {
      tabsEl.innerHTML = picker ? '' : buildTabs();
      tabsEl.style.display = picker ? 'none' : '';
    }
    if (shopEl) shopEl.style.display = picker ? 'none' : '';
    paintActive();
    paintShop();
  }

  function wrap() {
    var root = host.querySelector('.dokoyo-sg-root');
    if (!root || (shell && root.parentNode === mainEl)) return false;

    shell = document.createElement('div');
    shell.className = 'dky-fms-shell';
    tabsEl = document.createElement('nav');
    tabsEl.className = 'dky-fms-tabs';
    tabsEl.setAttribute('aria-label', cfg.tabsTitle || 'Choose a style');
    mainEl = document.createElement('div');
    mainEl.className = 'dky-fms-main';
    shopEl = document.createElement('div');
    shopEl.className = 'dky-fms-shop';

    root.parentNode.insertBefore(shell, root);
    shell.appendChild(tabsEl);
    shell.appendChild(mainEl);
    mainEl.appendChild(root);
    mainEl.appendChild(shopEl);

    tabsEl.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      if (e.target.closest('[data-fms-all]')) { backToAll(); return; }

      var b = e.target.closest('[data-fms-tab]');
      if (!b) return;
      var k = b.getAttribute('data-fms-tab');
      active = k;
      paintActive();
      if (window.DokoyoSizeGuide && window.DokoyoSizeGuide.open) {
        window.DokoyoSizeGuide.open(k);
      }
    });
    return true;
  }

  function watchPicks() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var pick = e.target.closest('.pickgrid [data-pick]');
      if (pick) {
        active = pick.getAttribute('data-pick');
        setTimeout(sync, 40);
        return;
      }

      /* "Measure me instead" di tabel ukuran: alat ukurnya dibuka oleh
         dokoyo-size-guide.js, lalu halaman digulirkan ke sana. */
      var jump = e.target.closest('[data-dokoyo-size-guide]');
      if (jump && host) {
        var k = jump.getAttribute('data-chart');
        if (k) active = k;
        setTimeout(function () {
          scrollToEl(host.closest('.shopify-section') || host);
          sync();
        }, 60);
      }
    }, true);
  }

  function hook() {
    var api = window.DokoyoSizeGuide;
    if (!api || api.__dkyHooked) return;
    var orig = api.open;
    api.open = function (key) {
      if (key) active = key;
      var r = orig.apply(this, arguments);
      setTimeout(sync, 0);
      return r;
    };
    api.__dkyHooked = true;
  }

  function boot() {
    host = document.querySelector('[data-dokoyo-size-guide-page]');
    if (!host) return;

    var section = host.closest('[data-dky-fms]');
    cfg = parse(section && section.getAttribute('data-dky-fms'), {});
    if (cfg.enabled === false) return;
    styles = parse(host.getAttribute('data-styles'), []) || [];

    var tries = 0;
    (function waitRoot() {
      var root = host.querySelector('.dokoyo-sg-root');
      if (root) {
        wrap();
        hook();
        watchPicks();
        sync();
        var body = root.querySelector('.sg-body');
        if (body && window.MutationObserver) {
          var t;
          new MutationObserver(function () {
            clearTimeout(t);
            t = setTimeout(sync, 30);
          }).observe(body, { childList: true, subtree: true });
        }
        return;
      }
      if (++tries < 80) setTimeout(waitRoot, 50);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function () {
    shell = null; tabsEl = null; shopEl = null; mainEl = null;
    setTimeout(boot, 60);
  });
})();
